// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9782f304","180":"203485d8","242":"ee427c65","252":"772facba","290":"10b95ab1","301":"aa3f9d57","306":"f38244ba","436":"d9607ef0","473":"516f1127","759":"ffce5bf1","937":"79c582c2"}[chunkId] + ".chunk.js";
};